import React from "react";
import FormInput, { NumberFormInput } from "../widgets/FormInput";
import TextArea from "../widgets/TextArea";
import { showSuccessToast } from "src/lib/utils";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editProduct } from "src/api/inventory";
import { Button } from "../ui/button";
import { usePortalContext } from "src/context/PortalContext";

const validationSchema = Yup.object().shape({
	name: Yup.string().required("This field is required"),
	sku: Yup.string().required("This field is required"),
	cost_price: Yup.string().required("This field is required"),
	price: Yup.string().required("This field is required"),
	description: Yup.string(),
});

const EditProductModal = ({ product }) => {
	const closePortal = usePortalContext();
	const queryClient = useQueryClient();

	const initialValues = {
		uuid: product.uuid,
		name: product.name || "",
		sku: product.sku || "",
		cost_price: product.cost_price || "",
		price: product.price || "",
		description: product.description || "",
		image: null,
	};

	const { mutate, isLoading } = useMutation(editProduct, {
		onSuccess: () => {
			showSuccessToast("Product updated successfully");
			queryClient.invalidateQueries(["inventory"]);
			closePortal();
		},
	});

	return (
		<Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={(values) => mutate(values)}>
			{({ values, handleChange, handleSubmit, setFieldValue }) => (
				<form onSubmit={handleSubmit}>
					<FormInput
						className="formItem !tw-w-full"
						label="Name"
						name="name"
						type="text"
						placeholder="Name"
						value={values.name}
						onChange={handleChange}
					/>

					<FormInput
						className="formItem !tw-w-full"
						label="SKU"
						name="sku"
						type="text"
						placeholder="SKU"
						value={values.sku}
						onChange={handleChange}
					/>

					<NumberFormInput
						className="formItem !tw-w-full"
						label="Cost Price"
						name="cost_price"
						type="text"
						placeholder="Cost Price"
						value={values.cost_price}
						onChange={(value) => setFieldValue("cost_price", value)}
					/>

					<NumberFormInput
						className="formItem !tw-w-full"
						label="Price"
						name="price"
						type="text"
						placeholder="Price"
						value={values.price}
						onChange={(value) => setFieldValue("price", value)}
					/>

					<TextArea label="Description" name="description" placeholder="Description" value={values.description} onChange={handleChange} />

					<FormInput
						className="formItem !tw-w-full"
						label="Image"
						name="image"
						type="file"
						onChange={(event) => setFieldValue("image", event.currentTarget.files[0])}
					/>

					<Button variant="secondary" className="tw-w-full" disabled={isLoading}>
						{isLoading ? "Updating..." : "Update Product Details"}
					</Button>
				</form>
			)}
		</Formik>
	);
};

export default EditProductModal;
